/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import { i18n } from '../../../lib/i18n';
import { Column } from '../../../atoms/layoutPrimitives';
import { ETypography, ETypographyColor } from '../../../types';
import { Typography } from '../../../atoms';
import { TDiscountModalVariant, TDiscountApplicant } from '../types';
import { Pricify } from '../../../lib/price';
import { Fragment, ReactNode } from 'react';

interface Props {
	totalAmount: number;
	type: TDiscountApplicant;
	subtotalBalance?: number;
	tabs?: ReactNode;
	variant: TDiscountModalVariant;
}

export const DiscountHeader = ({ totalAmount, subtotalBalance, type, tabs, variant }: Props) => {
	const labels = i18n.addDiscount.header;
	const isAll = type === 'all';

	return (
		<Column fullWidth gap={'1rem'}>
			<Typography type={ETypography.h6Accented} color={ETypographyColor.primary}>
				{labels.title}
			</Typography>
			<Typography type={ETypography.body2Accented} color={ETypographyColor.secondary}>
				{isAll
					? labels.amount(variant, Pricify(totalAmount, undefined, undefined, true))
					: labels.lineItemAmount(Pricify(totalAmount, undefined, undefined, true))}
			</Typography>
			{subtotalBalance ? (
				<Typography type={ETypography.body2Accented} color={ETypographyColor.secondary}>
					{labels.subtotalBalance(variant, Pricify(subtotalBalance, undefined, undefined, true))}
				</Typography>
			) : (
				<Fragment />
			)}
			{tabs}
		</Column>
	);
};
